import React, { Component, memo } from 'react';
import { serviceConstants } from '../../../../services/common/constants';
import { getUserAuthToken } from '../../../../services/common/util';

class QcBarcodes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            context: { componentParent: this }
        };
    }

    render() {
        const barcodes = this.props.match?.params?.barcodes ? this.props.match.params.barcodes.split(',') : [];
        return (
            <div
                className="clinic-contain d-flex flex-column"
                style={{
                    width: '100%'
                }}
            >
                {barcodes.map((barcode, index) => (
                    <div
                        style={{
                            borderBottom: index < barcodes.length - 1 ? '1px solid #ccc' : 'none',
                            padding: '15px'
                        }}
                    >
                        <img
                            src={
                                serviceConstants.API_HOST_NAME +
                                '/files/barcodeImages/' +
                                barcode.replace(/[^a-zA-Z0-9]/g, '') +
                                '.png?' +
                                new Date().getTime().toString() +
                                '&token=' +
                                getUserAuthToken()
                            }
                            alt={`Barcode ${index + 1}`}
                            key={index}
                            style={{ margin: '10px', width: '300px', height: 'auto' }}
                        />
                    </div>
                ))}
            </div>
        );
    }
}

export default QcBarcodes;
